<template>
  <SlotPanel v-if="updatedPerformance && selectedPerformance">
    <LabelReset
      class="mb-4"
      :initialValue="{ seatingTimes: selectedPerformance.seating_times, toDelete: [] }"
      :modelValue="{
        seatingTimes: updatedPerformance.seating_times,
        toDelete: seatingTimeIdsToBeDeleted,
      }"
      @update:modelValue="performanceUpdateStore.resetSeatingTimes"
    >
      Seating Times
    </LabelReset>

    <p
      id="warning-message"
      class="text-fg-error mb-4"
      v-if="!displaySeatingTimeList || allSeatingTimesWillBeDeleted"
    >
      There are no seating times. This will result in a Performance that appears to be sold out.
    </p>

    <div class="flex flex-col gap-2">
      <template v-if="displaySeatingTimeList">
        <PerformanceSeatingTimeItem
          v-for="seatingTime in updatedPerformance.seating_times"
          :key="seatingTime.id"
          :isDeleted="_.includes(seatingTimeIdsToBeDeleted, seatingTime.id)"
          :seatingTime="seatingTime"
          :initialSeatingTime="_.find(selectedPerformance.seating_times, { id: seatingTime.id })"
          @update:seatingTime="performanceUpdateStore.updateSeatingTime"
          @delete:seatingTime="performanceUpdateStore.handleSeatingTimeDeletion"
        />
      </template>

      <div
        id="add-seating-time-button"
        class="text-fg-secondary relative flex items-center justify-center cursor-pointer"
        @click="performanceUpdateStore.createSeatingTime"
      >
        <hr class="w-full border-linear-subtle absolute top-1/2 left-0" />
        <div class="w-6 h-6 bg-surface-primary z-10">
          <PlusCircleIcon class="w-full h-full" />
        </div>
      </div>
    </div>
  </SlotPanel>
</template>

<script setup lang="ts">
import * as _ from 'lodash-es'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import PlusCircleIcon from '@/assets/plusCircle.svg?component'
import LabelReset from '@/common/components/molecules/LabelReset.vue'
import SlotPanel from '@/common/components/organisms/SlotPanel.vue'
import PerformanceSeatingTimeItem from '@/modules/performance/components/molecules/PerformanceSeatingTimeItem.vue'
import { usePerformanceReservationStore } from '@/modules/performance/stores/PerformanceReservationStore'
import { usePerformanceUpdateStore } from '@/modules/performance/stores/PerformanceUpdateStore'

const performanceUpdateStore = usePerformanceUpdateStore()
const { updatedPerformance, seatingTimeIdsToBeDeleted } = storeToRefs(performanceUpdateStore)
const { selectedPerformance } = storeToRefs(usePerformanceReservationStore())

const allSeatingTimesWillBeDeleted = computed<boolean>(() => {
  if (!updatedPerformance.value) return false
  const seatingTimeIds = _.map(updatedPerformance.value.seating_times, 'id')
  return _.every(seatingTimeIds, id => _.includes(seatingTimeIdsToBeDeleted.value, id))
})
const displaySeatingTimeList = computed<boolean>(() => {
  if (!updatedPerformance.value) return false
  return updatedPerformance.value.seating_times.length > 0
})
</script>
